export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"hid":"description","name":"description","content":"تبادل ارز و انتقال آن به تمامی نقاط جهان با سرعت بالا، امنیت کامل و کمترین کارمزد. انتقال ارز در چند مرحله ساده و سریع. همین حالا شروع کنید!"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"icon","type":"image/png","href":"/favicon-32x32.png"},{"rel":"icon","sizes":"48x48","type":"image/png","href":"/favicon-32x32.png"},{"rel":"apple-touch-icon","type":"image/png","href":"/apple-touch-icon.png"},{"rel":"shortcut icon","sizes":"16x16","href":"/favicon-16x16.png"},{"rel":"shortcut icon","sizes":"32x32","href":"/favicon-32x32.png"},{"rel":"shortcut icon","sizes":"192x192","href":"/android-chrome-192x192.png"},{"rel":"shortcut icon","sizes":"512x512","href":"/android-chrome-512x512.png"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","href":"https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css"}],"style":[],"script":[{"hid":"mediaad","src":"https://s1.mediaad.org/serve/109075/retargeting.js","async":true,"type":"text/javascript"},{"hid":"gtm","src":"https://www.googletagmanager.com/gtm.js?id=GTM-54DCTNB3","async":true,"type":"text/javascript"}],"noscript":[]}

export const appBuildAssetsDir = "/_nuxt-home/"

export const appBaseURL = "/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const runtimeCompiler = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true